import { render } from "./FormularioPessoaFisica.vue?vue&type=template&id=371b8b5e&scoped=true"
import script from "./FormularioPessoaFisica.vue?vue&type=script&lang=js"
export * from "./FormularioPessoaFisica.vue?vue&type=script&lang=js"

import "./FormularioPessoaFisica.vue?vue&type=style&index=0&id=371b8b5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371b8b5e"]])

export default __exports__